import { createCrud } from '../../CRUD';
import { TWidgetUser } from './types';

export const widgetUserBaseModel = createCrud<TWidgetUser>('widgets', 'User');
